/**
 * 监听物理按钮的返回事件
 * 1.2版本之后， 安安卓物理键返回的动作将和右上角返回按钮动作表现一致。
 * base_listenBackButton
 * app:backButtonClick
 * 将会废弃不用
 * 配置物理键的返回动作 将会改成配置返回按钮 app:navbarLeftButtonClick 实现
 */
import {supportNative, getErrorFactory, logError} from './util';


const zzc = window.zzc;

export default function listen(listener) {
  let errorFactory = getErrorFactory('listenPhysicsBackButton');

  if (!supportNative('base_listenBackButton')) {
    return logError(errorFactory('不支持zzcjsbridge'));
  }

  //zzc.call('base_listenBackButton');
  //zzc.on('app:backButtonClick', listener);
  
  zzc.call('base_customNavbarLeftButton', {
    type: 'image', 
    imageUrl: 'back',
    topImageUrl:'',
    text: '', // 要显示的文字
    success: function (response) {
    }
  });
  zzc.on('app:navbarLeftButtonClick', listener);
}



// WEBPACK FOOTER //
// ./src/native/listenPhysicsBackButton.js